import { WORKSPACE_AGENT_PANEL_WIDTH_CSS_VARIABLE } from '~/components/v2/components/workspace/workspace-agent-panel/workspaceAgentPanelConstants';

export const syncWorkspaceAgentPanelWidthToCSS = (width: number): void => {
  if (typeof document !== 'undefined') {
    document.documentElement.style.setProperty(WORKSPACE_AGENT_PANEL_WIDTH_CSS_VARIABLE, `${width}px`);
  }
};
